"use strict";

exports.__esModule = true;
exports.getHeader = void 0;

var getHeader = function getHeader(headers, headerName) {
  headerName = headerName.toLowerCase();
  return headers.get ? headers.get(headerName) : headers[headerName];
};

exports.getHeader = getHeader;